<div class="send-money head-top">
  <p class="sm-18 font-weight-bold color-blue pl-2">Confirm amount and select payment method</p>
  <div class="col-lg-4 col-sm-12 p-0 ml-2 mt-2">
    <form>
      <div class="div-block-13 bg-white w-100">
        <input type="number" name="sending_amount" class="text-field w-input m-0 p-3 border-0" def="10" autofocus="true"
          maxlength="256" name="sending_amt" [(ngModel)]="billerService.finalData['amount_cad']" readonly required>
        <div class="w-dropdown bg-alice radiusr-5">
          <div class="dropdown-toggle-2 w-dropdown-toggle p-3">
            <div id="from-currency" class="div-block-11 mr-0">
              <div class="selected-currency-code color-blue mr-1">{{auth.user.currency.toUpperCase()}}</div>
              <img [src]="'assets/images/'+auth.user.currency.toLowerCase()+'.png'" loading="lazy"
                alt="n2xpress - Money Transfer - Canadian Dollar" class="image-7  m-0" width="25" height="25">
            </div>
          </div>
        </div>
      </div>
      <div class="rate-panel mb-5">
        <div class="side-line h-auto"></div>
        <div class="div-block-16">
          <div class="div-block-18-copy py-3">
            <span class="bg-alice rounded-circle symbol color-blue">x</span>
            <div class="rate-figure">
              <div id="currency-rate" class="text-block-12">{{ billerService.finalData['exchange_rate_cad'] }}</div>
            </div>
            <div class="rate-currency">
              <div id="exchange-currency" class="rate-currency-text">{{ billerService.biller.currency.toUpperCase() }}
              </div>
            </div>
            <div class="rate-explainer">
              <div class="explainer-text sm-10">Your exchange rate</div>
            </div>
          </div>
          <div class="div-block-13-copy w-100 bg-white">
            <span class="bg-alice rounded-circle symbol color-blue">=</span>
            <input type="number" readonly style="background:none!important; border:none;" class="text-field w-input m-0"
              maxlength="256" name="send_amt" [(ngModel)]="billerService.finalData['biller_amount_local']">
            <div class="w-dropdown bg-alice radiusr-5">
              <div class="dropdown-toggle-2 w-dropdown-toggle p-3">
                <div id="to-currency" class="div-block-11 mr-0">
                  <div class="text-block-10 color-blue receiveCountry">{{billerService.biller.currency.toUpperCase()}}
                  </div>
                  <img [src]="'assets/images/'+billerService.biller.currency.toLowerCase()+'.png'" loading="lazy"
                    [alt]="'n2xpress - Money Transfer - ' + billerService.biller.currency"
                    class="image-7 receive-moneyImg m-0 flag-send-money">
                </div>
              </div>
            </div>
          </div>
          <div class="div-block-17-copy pt-3">
            <span class="bg-alice rounded-circle symbol color-blue">+</span>
            <div>
              <div class="fee-figure">{{ billerService.finalData['transaction_fees'] }}</div>
            </div>
            <div class="rate-currency">
              <div class="rate-currency-text">CAD</div>
            </div>
            <div class="fee-explainer-text">
              <div class="explainer-text">Processing fees</div>
            </div>
          </div>
          <div (click)="onSelectPaymentMethod(option)"
            class="select-payment mt-3 w-100 radius-5 border-blue d-flex align-items-center cursor-pointer"
            *ngFor="let option of options" [ngClass]="{'bg-alice' : sendMoney.selectedCAPaymentMethod==option }">
            <div class="text-block-10 send-via-Interac sm-14 w-100 p-0 m-0">
              <div class="row m-0 p-0">
                <div class="col-10 sm-10 color-blue gilroy-bold px-1 d-flex justify-content-between align-items-center">
                  {{option.description}} ({{ !option.gateway_fee_type ? ''+option.gateway_fee+' CAD' :
                  option.gateway_fee+' %'}})


                </div>
                <div class="col-2 p-0 text-center">
                  <!-- <img src="assets/images/b3.png" style="height:22px;width:22px" alt=""> -->
                  <img *ngFor="let image of option.image.split(',')" [src]="image" style="width:40px"
                    [alt]="option.description">

                </div>
                <!-- <div class="col-4 p-0 color-blue gilroy-bold sm-10"> ${{ option.gateway_fee }} CAD</div> -->
                <!-- <div class="col-4 pl-1 pr-0 mt-2">+ $0.00 USD</div> -->
              </div>
            </div>
          </div>

          <div class="div-block-18-copy pt-3">
            <span class="bg-alice rounded-circle symbol color-blue">=</span>
            <div class="rate-figure">
              <div id="currency-rate" class="text-block-12">{{ amountWithGatewayFees }}</div>
            </div>
            <div class="rate-currency">
              <div id="exchange-currency" class="rate-currency-text">CAD</div>
            </div>
            <div class="rate-explainer">
              <div class="explainer-text">Total you will be charged</div>
            </div>
          </div>

          <!-- Happy -->
          <div *ngIf="celoData.paymentSelectedoption != null && celoData.paymentSelectedoption.payment_id == 6"
            [ngClass]="celoData.paymentSelectedoption != null && celoData.paymentSelectedoption.payment_id != 6  ? 'display_none': ''">
            <div class="div-block-18-copy pt-3">
              <span class="bg-alice rounded-circle symbol color-blue">=</span>
              <div class="rate-figure">
                <div id="celo-currency-rate" class="text-block-12">{{celoData.data.celo_value_plus_fee}}</div>
              </div>
              <div class="rate-explainer">
                <div class="explainer-text">cUSD</div>
              </div>
            </div> <br>

            <p>Please enter the wallet number from which you will initiate the transaction.
              If this address does not match the deposit transaction hash we will not be able to process the transaction.
            </p>

            <div>
              <input type="text" (keypress)="special_char($event)"  required [(ngModel)]="celoData.celoWalletNumber" name="celoWalletNumber"
                class="form-control promocode-form p-0" placeholder="Celo wallet number Ex-12345">
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-between">
        <button type="button" (click)="billerService.prevPage('biller1')"
          class="btn transparent-btn primary-text text-center w-50">Back</button>
        <button type="button" (click)="checkAndProceed()" class="btn px-5 primary-btn text-white w-50"
          [disabled]="!sendMoney.selectedCAPaymentMethod || (!celoData.celoWalletNumber && celoData.paymentSelectedoption.payment_id == 6)">Next</button>

          
          <!--  &&  -->
      </div>
    </form>
  </div>
</div>